<template>
    <div class="alarm-control" style="padding: 10px;">
        <el-row :gutter="20">
            <el-col :span="12">
                <el-card shadow="hover">
                    <div slot="header" style="display:flex;align-items:center;justify-content:space-between;">
                        <span>{{ $t('pages.alarmControl.title') }}</span>
                        <div>
                            <el-button size="mini" type="primary" icon="el-icon-refresh" @click="fetchStatus">{{ $t('common.refresh') }}</el-button>
                        </div>
                    </div>
                    
                    <div class="status-container" style="display: flex; flex-direction: column; align-items: center; padding: 40px 0;">
                        <!-- 状态指示灯 -->
                        <div class="status-indicator" :class="alarmStatus ? 'is-active' : 'is-muted'" style="margin-bottom: 20px;">
                            <div class="light" :style="{ backgroundColor: alarmStatus ? '#f56c6c' : '#67c23a', width: '100px', height: '100px', borderRadius: '50%', boxShadow: alarmStatus ? '0 0 20px #f56c6c' : '0 0 20px #67c23a', transition: 'all 0.3s' }"></div>
                        </div>
                        
                        <div class="status-text" style="font-size: 24px; font-weight: bold; margin-bottom: 40px;" :style="{ color: alarmStatus ? '#f56c6c' : '#67c23a' }">
                            {{ alarmStatus ? $t('pages.alarmControl.statusActive') : $t('pages.alarmControl.statusMuted') }}
                        </div>

                        <!-- 控制操作区 -->
                        <div class="control-actions">
                            <el-button 
                                type="danger" 
                                size="large" 
                                @click="toggleAlarm(true)"
                                style="width: 150px; margin-right: 20px;">
                                {{ $t('pages.alarmControl.turnOn') }}
                            </el-button>
                            <el-button 
                                type="success" 
                                size="large" 
                                @click="toggleAlarm(false)"
                                style="width: 150px;">
                                {{ $t('pages.alarmControl.turnOff') }}
                            </el-button>
                        </div>
                    </div>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
    name: 'AlarmControl',
    data() {
        return {
            alarmStatus: false, // false: 消音/关闭, true: 报警中
            loading: false
        };
    },
    created() {
        this.fetchStatus();
    },
    methods: {
        // 获取当前状态
        fetchStatus() {
            this.loading = true;
            this.$zybhttp
                .post('Business/GetAlarmOutputStatus', {})
                .then((res) => {
                    this.loading = false;
                    let responseData = res.data || res;
                    
                    let outputEnabledValue = null;
                    let found = false;

                    // 兼容各种嵌套结构的解析，同时兼容大小写 (OutputEnabled / outputEnabled)
                    const getOutputEnabled = (obj) => {
                        if (!obj) return undefined;
                        if (obj.outputEnabled !== undefined) return obj.outputEnabled;
                        if (obj.OutputEnabled !== undefined) return obj.OutputEnabled;
                        return undefined;
                    };

                    let valFromDataData = responseData && responseData.data ? getOutputEnabled(responseData.data) : undefined;
                    let valFromData = getOutputEnabled(responseData);
                    let valFromRes = getOutputEnabled(res);

                    if (valFromDataData !== undefined) {
                        outputEnabledValue = valFromDataData;
                        found = true;
                    } else if (valFromData !== undefined) {
                        outputEnabledValue = valFromData;
                        found = true;
                    } else if (valFromRes !== undefined) {
                        outputEnabledValue = valFromRes;
                        found = true;
                    } else if (typeof responseData === 'boolean' || typeof responseData === 'string') {
                        // 有可能接口直接返回 true/false
                        if (String(responseData).toLowerCase() === 'true' || String(responseData).toLowerCase() === 'false') {
                            outputEnabledValue = responseData;
                            found = true;
                        }
                    }

                    if (found) {
                        this.alarmStatus = String(outputEnabledValue).toLowerCase() === 'true';
                    } else {
                        // 如果完全没找到该字段，但 HTTP 是 200，则默认认为可能是关闭，或者打印错误
                        console.warn('未找到 outputEnabled/OutputEnabled 字段，返回内容:', res);
                        if (res.status === 200) {
                            this.alarmStatus = false;
                        } else {
                            this.$notify.error(responseData.message || responseData.msg || '获取状态失败，字段解析异常');
                        }
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.$notify.error('获取状态异常');
                    console.error(err);
                });
        },
        // 切换状态
        toggleAlarm(enabled) {
            const confirmMsg = enabled ? this.$t('pages.alarmControl.turnOn') : this.$t('pages.alarmControl.turnOff');
            this.$confirm(`确定要${confirmMsg}吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.loading = true;
                // 注意：根据用户要求，接口为 /api/v1/Business/AlarmOutputSwitch?enabled=xxx
                this.$zybhttp
                    .post(`Business/AlarmOutputSwitch?enabled=${enabled}`)
                    .then((res) => {
                        this.loading = false;
                        let responseData = res.data || res;
                        // 放宽成功条件的判断
                        if (responseData.status == 0 || responseData.code == 200 || responseData.status == 200 || res.status === 200 || responseData === '') {
                            this.$notify.success(`${enabled ? this.$t('pages.alarmControl.turnOn') : this.$t('pages.alarmControl.turnOff')}成功`);
                            this.fetchStatus(); // 刷新状态
                        } else {
                            this.$notify.error(responseData.message || responseData.msg || '操作失败');
                            this.fetchStatus(); // 刷新状态
                        }
                    })
                    .catch((err) => {
                        this.loading = false;
                        this.$notify.error('操作异常');
                        console.error(err);
                    });
            }).catch(() => {});
        }
    }
};
</script>

<style scoped>
.alarm-control {
    width: 100%;
    height: 100%;
}
</style>
